import { reduxActions as FILE } from "_constants/file.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";
import initialFileState from "../file.initialState";

const remove = {
  [FILE.REMOVE_STARTED]: (state) => ({
    ...state,
    remove: {
      ...state.remove,
      status: LOADING
    }
  }),
  [FILE.REMOVE_FAIL]: (state, { payload}) => ({
    ...state,
    remove: {
      ...state.remove,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),
  [FILE.REMOVE_SUCCESS]: (state, { payload}) => ({
    ...state,
    remove: {
      ...state.remove,
      data: payload?.data ?? null,
      status: SUCCESS
    }
  }),
  [FILE.REMOVE_RESET]: (state) => ({
    ...state,
    remove: initialFileState.remove
  }),
};

export default remove;
